import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { ProjectName, ProjectNameDTO } from "../types/projectName";

export interface ProjectDTO {
  id: string;
  projectName: ProjectNameDTO;
  archived: boolean;
}

export class Project {
  readonly isProjectProject: boolean = true;

  readonly id: LeoUUID;
  readonly projectName: ProjectName;
  readonly archived: boolean;


  constructor(
  id: LeoUUID, 
  projectName: ProjectName, 
  archived: boolean
  ) {
    this.id = id;
    this.projectName = projectName;
    this.archived = archived;
  }

  static fromDTO(dto: ProjectDTO): Project {
    const id = getLeoUuid(dto, "id", InvalidProjectIdError);
    const projectName = ProjectName.fromDTO(getObject(dto, "projectName", InvalidProjectProjectNameError));
    const archived = getBoolean(dto, "archived", InvalidProjectArchivedError);
    return new Project(
      id,
      projectName,
      archived
    );
  }

  toDTO(): ProjectDTO {
    const dto: ProjectDTO = {
        id: this.id.toDTO(),
        projectName: this.projectName.toDTO(),
        archived: this.archived
    };
    return dto;
  }
  }

Project.prototype.toString = function toString(): string {
  return `Project(id='${this.id}',projectName='${this.projectName}',archived='${this.archived}')`;
};

export class InvalidProjectError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectError";
  }
}
export class InvalidProjectIdError extends InvalidProjectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectIdError";
  }
}

export class InvalidProjectProjectNameError extends InvalidProjectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectProjectNameError";
  }
}

export class InvalidProjectArchivedError extends InvalidProjectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectArchivedError";
  }
}
